import React, { Suspense, lazy } from "react";
import { motion } from "framer-motion";

// Lazy load components
const Hero = lazy(() => import("../components/home/Hero"));
const About = lazy(() => import("../components/home/About"));
const Services = lazy(() => import("../components/home/Services"));
const Portfolio = lazy(() => import("../components/home/Portfolio"));
const CallToAction = lazy(() => import("../components/home/CallToAction"));
const UpcomingEvents = lazy(() => import("../components/home/UpcomingEvents"));
const SupportedEvents = lazy(() => import("../components/home/SupportedEvents"));
const Testimonials = lazy(() => import("../components/home/Testimonials"));
const AnnualSponsors = lazy(() => import("../components/home/AnnualSponsors"));
const TeamPreview = lazy(() => import("../components/home/TeamPreview"));
const FinalCTA = lazy(() => import("../components/home/FinalCTA"));
const TourAnnouncement = lazy(() => import("../components/home/TourAnnouncement"));
const NepalRelief = lazy(() => import("../components/home/NepalRelief"));

// Loading fallback component
const LoadingFallback = () => (
  <div
    style={{
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0b0908",
    }}
  >
    <div className="loading-spinner" />
  </div>
);

const Home = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Suspense fallback={<LoadingFallback />}>
        <TourAnnouncement />
        {/* 1. Hero */}
        <Hero />
        {/* 1b. Together for Nepal flood relief campaign */}
        <NepalRelief />
        {/* 2. Brand Introduction */}
        <About />
        {/* 3. The 3Es */}
        <Services />
        {/* 4. Upcoming / Future Events */}
        <UpcomingEvents />
        {/* 5. Events Supported by 3E Entertainment */}
        <SupportedEvents />
        {/* 6. Youth & Impact */}
        <CallToAction />
        {/* 7. Signature Events & Legacy (past) */}
        <Portfolio />
        {/* 8. Partners */}
        <Testimonials />
        {/* 9. Annual Sponsors */}
        <AnnualSponsors />
        {/* 10. Team Preview */}
        <TeamPreview />
        {/* 11. Contact CTA */}
        <FinalCTA />
      </Suspense>
    </motion.div>
  );
};

export default Home;
